import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import classNames from 'classnames';
import { Record } from 'immutable';

import { track } from '@xanadu/ui-shared/interfaces/woopra';
import { BETSLIP_PRODUCTS } from '@xanadu/ui-shared/constants';

import Market from '../../Market';
import BetBuilderLegs from '../BetBuilderLegs';
import OfferEdit from '../OfferEdit/OfferEdit';

import UnmatchedIcon from '../../../../../images/icons/misc/icon-betslip.svg';
import PromoIcon from '../../../../../images/betslip/UI_promos.svg';

import helpers from '../../../../../javascripts/helpers';
import { odds as localiseOdds } from '../../../../utils/localise';

import OfferButtons from '../OfferButtons/OfferButtons';
import { PRODUCTS } from '../../../../constants';
import { Dropdown, Option as DropdownOption } from '../../../widgets/Dropdown';

import style from './OfferInfo.module.scss';

const OfferInfo = ({
  offer,
  showCashout,
  aggregationRule,
  oddsType,
  setEditModal,
  setUnmatchedData,
  unmatchedData,
  editModal,
  betData,
  confirmed,
  offerIndex,
  currency,
  updateBack,
  updateLay,
  oddsLadder,
  updateOdds,
  refOdds,
  handleSubmit,
  reset,
  stringIsValidNumber,
  refInputStake,
  onRemoveMultipleSelection,
  processingState,
  onRemoveOffer,
  onCancelOffer,
  countdown,
  showBetConfirmation,
  cashoutAvailable,
  marketStatus,
  onCancelUnmatchedOffers,
  selectRunner,
  setShowCashout,
  setConfirmed,
  isNew,
  eventInRunning,
  isLoggedIn,
  marketWillBeLive,
  handleKeepInPlay,
  bonusBalance,
  chooseKeep,
  bonusAllowed,
  handleUseBonus,
  optionValue,
  bonusDropdownOptions,
  updateOddsLockStatus,
  oddsLocked,
  lastEditedInput,
  isUnsubmittedType,
  isBetBuilderBet,
  isMobile,
  betBuilderWithErrors,
  betBuilderLegsWithErrors,
  showBetBuilderOddsAcceptance,
  acceptNewBetBuilderOdds,
  newBetBuilderOdds,
  prevBetBuilderOdds,
}) => {
  const [editUnmatched, setEditUnmatched] = useState(false);
  const [betBuilderLegsExpanded, setBetBuilderLegsExpanded] = useState(false);

  const {
    unmatched: activeUnmatchedBets = [],
    legs: betBuilderLegs,
  } = offer;

  const unmatchedUseBonus = activeUnmatchedBets.length === 1 ?
    activeUnmatchedBets[0].useBonus : false;

  const activeOffer = ['open', 'matched', 'edited'].includes(offer.status);

  const isMBZero = offer.product === PRODUCTS.mbzero;

  const isSubmitting = processingState === 'submitting';

  const activeProduct = isBetBuilderBet ? BETSLIP_PRODUCTS.betbuilder : BETSLIP_PRODUCTS.exchange;

  const bonusDropdownOptionsLockByProduct = bonusDropdownOptions.filter(
    ({ products }) => (products.includes(activeProduct)));

  let marketName = offer.marketName;
  let runnerName = offer.runnerName;

  if (isBetBuilderBet) {
    marketName = isUnsubmittedType ? offer.eventName : '';
    runnerName = 'Bet Builder';
  }

  const showFreeBet = bonusAllowed
    && bonusBalance >= 0.1
    && isUnsubmittedType
    && !isSubmitting;

  const currencyFormatter = helpers.localise.currency;

  const handleEditUnmatched = (unmatchedBetId) => {
    setUnmatchedData(unmatchedBetId);
    setEditModal(true);
  };

  const handleBetBuilderLegsAccordion = () => {
    setBetBuilderLegsExpanded(!betBuilderLegsExpanded);
  };

  const handleEdit = () => {
    if (activeUnmatchedBets.length <= 1) {
      setEditModal(true);
      if (activeUnmatchedBets.length === 1) {
        setUnmatchedData(activeUnmatchedBets[0].offerId);
      }
    } else {
      setEditUnmatched(true);
    }
    track('Betslip', 'Clicked Edit Button');
  };

  let stake = 0;
  let pnl = 0;
  let odds = 0;

  const resetEditing = () => {
    setEditUnmatched(false);
    setEditModal(false);
    setUnmatchedData(null);
    reset();
  };

  if (isBetBuilderBet) {
    odds = offer.remote.odds;
    stake = offer.remote.backersStake;
    pnl = offer.remote.layersStake;
  }


  if (!isBetBuilderBet && offer.status === 'matched' && aggregationRule !== 'AVG') {
    stake = offer.matchedBets.last().stake;
    odds = offer.matchedBets.last().odds;
    if (offer.side === 'lay') {
      pnl = offer.matchedBets.last().potentialLiability === 0
        ? ((odds * stake) - stake)
        : offer.matchedBets.last().potentialLiability;
    } else {
      pnl = offer.matchedBets.last().potentialProfit === 0
        ? ((odds * stake) - stake)
        : offer.matchedBets.last().potentialProfit;
    }
  }

  if (offer.status === 'open' && aggregationRule !== 'AVG') {
    if (offer.matchedBets.size > 0) {
      offer.matchedBets.forEach((matchedBet) => {
        stake += matchedBet.stake;
        pnl = matchedBet.potentialProfit > 0
          ? pnl + matchedBet.potentialProfit
          : ((matchedBet.odds * matchedBet.stake) - matchedBet.stake);
        odds = offer.remote.odds !== matchedBet.odds ? offer.remote.odds : matchedBet.odds;
      });
    } else {
      stake = 0;
      pnl = 0;
      odds = offer.remote.odds;
    }
  }

  if (offer.status === 'edited' && aggregationRule !== 'AVG') {
    if (offer.matchedBets.size > 0) {
      offer.matchedBets.forEach((matchedBet) => {
        if (matchedBet.odds === offer.remote.odds) {
          stake += matchedBet.stake;
          pnl = matchedBet.potentialProfit > 0
            ? pnl + matchedBet.potentialProfit
            : ((matchedBet.odds * matchedBet.stake) - matchedBet.stake);
          odds = offer.remote.odds !== matchedBet.odds ? offer.remote.odds : matchedBet.odds;
        } else {
          stake = 0;
          pnl = 0;
          odds = offer.remote.odds;
        }
      });
    } else {
      stake = 0;
      pnl = 0;
      odds = offer.remote.odds;
    }
  }

  if (!isBetBuilderBet && aggregationRule === 'AVG') {
    if (offer.matchedBets.size > 0) {
      stake = offer.matchedBets.last().stake;
      pnl = offer.matchedBets.last().potentialProfit || offer.matchedBets.last().potentialLiability;
      odds = offer.matchedBets.last().odds;
    } else {
      stake = offer.remote.stake;
      pnl = offer.remote.potentialProfit || offer.remote.potentialLiability;
      odds = offer.remote.odds;
    }
  }

  const unmatchedLabel = classNames({
    [style.unmatchedLabel]: true,
    [style[`unmatchedLabel--${offer.side}`]]: true,
  });

  const radio = classNames({
    [style.radio]: true,
    [style[`radio--${offer.side}`]]: true,
  });

  const unmatchedLabelToEdit = classNames({
    [style.unmatchedLabelToEdit]: true,
    [style[`unmatchedLabelToEdit--${offer.side}`]]: true,
  });

  const containerIconAndLabel = classNames({
    [style.containerIconAndLabel]: true,
    [style[`containerIconAndLabel--${offer.side}`]]: true,
  });

  const oddsClass = classNames(style.betData, style['betData--odds']);
  const stakeClass = classNames(style.betData, style['betData--stake']);
  const pnlClass = classNames(style.betData, style['betData--pnl']);

  const containerSecondRow = classNames({
    [style.containerSecondRow]: true,
  });

  return (
    <div>
      {activeOffer ? (
        <Fragment>
          <div>
            <div className={style.containerEdit}>
              <Market
                marketName={offer.marketName}
                runnerName={offer.runnerName}
                eventId={offer.eventId}
                product={offer.product}
                isBetBuilderBet={isBetBuilderBet}
                betType="active"
                key={`market_${offer.cid}_${offer.id}`}
              />
              <div className={style.containerResume}>
                <span className={oddsClass}>
                  {localiseOdds(odds, { side: offer.side, oddsType, isMBZero })}
                </span>
                <span className={stakeClass}>
                  {currencyFormatter(stake, { minimumFractionDigits: 2 })}
                </span>
                <span className={pnlClass}>
                  {currencyFormatter(pnl, { minimumFractionDigits: 2 })}
                </span>
              </div>
            </div>
            {isBetBuilderBet && (
              <BetBuilderLegs
                betType="active"
                betBuilderLegs={betBuilderLegs}
                betBuilderLegsExpanded={betBuilderLegsExpanded}
                betBuilderLegsWithErrors={betBuilderLegsWithErrors}
                handleBetBuilderLegsAccordion={handleBetBuilderLegsAccordion}
                offer={offer}
              />
            )}
          </div>
          {!isBetBuilderBet && (
            <Fragment>
              {((offer.status === 'open' || offer.status === 'edited') && !editUnmatched) ? (
                <Fragment>
                  <div className={unmatchedLabel} onClick={() => handleEdit()} role="button">
                    <div className={style.containerFirstRow}>
                      <span className={containerIconAndLabel}>
                        <UnmatchedIcon /> Unmatched  {offer.useBonus || unmatchedUseBonus && <PromoIcon />}
                      </span>
                    </div>
                    <div className={containerSecondRow}>
                      <span className={oddsClass}>
                        {localiseOdds(offer.remote.odds, { side: offer.side, oddsType, isMBZero })}
                      </span>
                      <span className={stakeClass}>
                        {currencyFormatter(offer.remaining, { minimumFractionDigits: 2 })}
                      </span>
                      <span className={pnlClass}>
                        {currencyFormatter((offer.remote.layersStake), {
                          minimumFractionDigits: 2
                        })}
                      </span>
                    </div>
                  </div>
                  <div>
                    {(!showCashout) && (
                      <Fragment>
                        <OfferEdit
                          offer={offer}
                          oddsLadder={oddsLadder}
                          oddsType={oddsType}
                          offerIndex={offerIndex}
                          refInputStake={refInputStake}
                          showBetConfirmation={showBetConfirmation}
                          setConfirmed={setConfirmed}
                          refOdds={refOdds}
                          betData={betData}
                          editModal={editModal}
                          confirmed={confirmed}
                          currency={currency}
                          updateBack={updateBack}
                          updateLay={updateLay}
                          updateOdds={updateOdds}
                          reset={reset}
                          handleSubmit={handleSubmit}
                          stringIsValidNumber={stringIsValidNumber}
                          setUnmatchedData={setUnmatchedData}
                          setEditModal={setEditModal}
                          isUnsubmittedType={isUnsubmittedType}
                          isMobile={isMobile}
                          processingState={processingState}
                          countdown={countdown}
                          eventInRunning={eventInRunning}
                          unmatchedData={unmatchedData}
                          onCancelOffer={onCancelOffer}
                          onCancelUnmatchedOffers={onCancelUnmatchedOffers}
                          unmatchedBetUseBonus={offer.useBonus || unmatchedUseBonus}
                        />
                      </Fragment>
                    )}
                  </div>
                  {(offer.useBonus || unmatchedUseBonus) && (
                    <div className={style.bonusLabel}>Free Bets are not editable</div>
                  )}
                </Fragment>
              ) : (
                activeUnmatchedBets.length > 1 && (
                  <Fragment>
                    <div className={style.unmatchedBetTitle}>
                      <span>Select Unmatched Bet to edit:</span>
                    </div>
                    {activeUnmatchedBets.map((unmatchedBet) => (
                      <Fragment key={unmatchedBet.offerId}>
                        <div className={unmatchedLabelToEdit} onClick={() => handleEditUnmatched(unmatchedBet.offerId)} role="button">
                          <div className={style.containerFirstRow}>
                            <span className={containerIconAndLabel}>
                              <UnmatchedIcon /> Unmatched {unmatchedBet.useBonus && <PromoIcon />}
                            </span>
                          </div>
                          <div className={containerSecondRow}>
                            <span className={oddsClass}>
                              {localiseOdds(unmatchedBet.odds, {
                                side: offer.side,
                                oddsType,
                                isMBZero
                              })}
                            </span>
                            <span className={stakeClass}>
                              {currencyFormatter(unmatchedBet.remote.backersStake, {
                                minimumFractionDigits: 2
                              })}
                            </span>
                            <span className={pnlClass}>
                              {currencyFormatter((unmatchedBet.remote.layersStake), {
                                minimumFractionDigits: 2
                              })}
                            </span>
                          </div>
                        </div>
                        <div>
                          {(!showCashout && unmatchedData === unmatchedBet.offerId) && (
                            <Fragment>
                              <OfferEdit
                                offer={offer}
                                oddsLadder={oddsLadder}
                                oddsType={oddsType}
                                offerIndex={offerIndex}
                                refInputStake={refInputStake}
                                showBetConfirmation={showBetConfirmation}
                                setConfirmed={setConfirmed}
                                refOdds={refOdds}
                                betData={betData}
                                editModal={editModal}
                                confirmed={confirmed}
                                currency={currency}
                                updateBack={updateBack}
                                updateLay={updateLay}
                                updateOdds={updateOdds}
                                reset={reset}
                                handleSubmit={handleSubmit}
                                stringIsValidNumber={stringIsValidNumber}
                                setUnmatchedData={setUnmatchedData}
                                setEditModal={setEditModal}
                                isUnsubmittedType={isUnsubmittedType}
                                isMobile={isMobile}
                                countdown={countdown}
                                eventInRunning={eventInRunning}
                                processingState={processingState}
                                unmatchedData={unmatchedData}
                                onCancelOffer={onCancelOffer}
                                onCancelUnmatchedOffers={onCancelUnmatchedOffers}
                                unmatchedBetUseBonus={unmatchedBet.useBonus}
                              />
                            </Fragment>
                          )}
                        </div>
                      </Fragment>
                    ))}
                  </Fragment>
                )
              )}
              <OfferButtons
                offer={offer}
                isLoggedIn={isLoggedIn}
                eventInRunning={eventInRunning}
                handleSubmit={handleSubmit}
                editModal={editModal}
                offerIndex={offerIndex}
                confirmed={confirmed}
                isNew={isNew}
                setEditModal={setEditModal}
                showBetConfirmation={showBetConfirmation}
                setConfirmed={setConfirmed}
                reset={reset}
                countdown={countdown}
                onRemoveMultipleSelection={onRemoveMultipleSelection}
                onRemoveOffer={onRemoveOffer}
                onCancelOffer={onCancelOffer}
                onCancelUnmatchedOffers={onCancelUnmatchedOffers}
                cashoutAvailable={cashoutAvailable}
                marketStatus={marketStatus}
                selectRunner={selectRunner}
                setShowCashout={setShowCashout}
                showCashout={showCashout}
                history={history}
                processingState={processingState}
                activeOffer={activeOffer}
                aggregationRule={aggregationRule}
                isMBZero={isMBZero}
                betData={betData}
                oddsType={oddsType}
                setEditUnmatched={setEditUnmatched}
                editUnmatched={editUnmatched}
                unmatchedData={unmatchedData}
                setUnmatchedData={setUnmatchedData}
                handleEdit={handleEdit}
                resetEditing={resetEditing}
              />
            </Fragment>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <Market
            marketName={marketName}
            runnerName={runnerName}
            eventId={offer.eventId}
            betType="unsubmitted"
            key={`market_${offer.cid}_${offer.id}`}
          />
          {isBetBuilderBet && (
            <BetBuilderLegs
              betType="unsubmitted"
              betBuilderLegs={betBuilderLegs}
              betBuilderLegsExpanded={betBuilderLegsExpanded}
              betBuilderLegsWithErrors={betBuilderLegsWithErrors}
              handleBetBuilderLegsAccordion={handleBetBuilderLegsAccordion}
              offer={offer}
            />
          )}
          <OfferEdit
            offer={offer}
            processingState={processingState}
            oddsLadder={oddsLadder}
            oddsType={oddsType}
            offerIndex={offerIndex}
            refInputStake={refInputStake}
            showBetConfirmation={showBetConfirmation}
            setConfirmed={setConfirmed}
            refOdds={refOdds}
            betData={betData}
            editModal={editModal}
            confirmed={confirmed}
            currency={currency}
            updateBack={updateBack}
            updateLay={updateLay}
            updateOdds={updateOdds}
            reset={reset}
            handleSubmit={handleSubmit}
            stringIsValidNumber={stringIsValidNumber}
            setUnmatchedData={setUnmatchedData}
            setEditModal={setEditModal}
            oddsLocked={oddsLocked}
            updateOddsLockStatus={updateOddsLockStatus}
            lastEditedInput={lastEditedInput}
            isUnsubmittedType={isUnsubmittedType}
            isMobile={isMobile}
            countdown={countdown}
            eventInRunning={eventInRunning}
            isBetBuilderBet={isBetBuilderBet}
            newBetBuilderOdds={newBetBuilderOdds}
            prevBetBuilderOdds={prevBetBuilderOdds}
            betBuilderWithErrors={betBuilderWithErrors}
          />
          {showFreeBet && bonusDropdownOptionsLockByProduct.length > 1 && (
            <div className={style.containerSelectProperties}>
              <div className={style.bonusTitle}>
                <span className={style.bonusText}>Select Free Bet:</span>
              </div>
              <Dropdown
                theme="dark"
                layout="outlined"
                useDesktopDropdown
                value={optionValue}
                items={bonusDropdownOptionsLockByProduct}
                selectLabel="Select"
                onSelect={(value) => handleUseBonus(value)}
              >
                {bonusDropdownOptionsLockByProduct.map(option => (
                  <DropdownOption
                    key={option.id}
                    value={option}
                  >
                    {option.name}
                  </DropdownOption>
                ))}
              </Dropdown>
            </div>
          )}
          {isUnsubmittedType
            && ((!eventInRunning && marketWillBeLive) || (bonusBalance >= 0.1))
            && (
              <div className={style.containerOptions}>
                {!eventInRunning && marketWillBeLive && (
                  <Fragment>
                    <div className={style.containerOption}>
                      <span className={style.optionsText}>Keep In Play</span>
                    </div>
                    <div className={style.containerOption}>
                      <div className={style.radioContainer}>
                        <div onClick={() => handleKeepInPlay(false)} role="button" className={style.radioLabelContainer}>
                          <input type="radio" onChange={() => handleKeepInPlay(false)} checked={!chooseKeep} className={radio} />
                          <span>No</span>
                        </div>
                        <div onClick={() => handleKeepInPlay(true)} role="button" className={style.radioLabelContainer}>
                          <input type="radio" onChange={() => handleKeepInPlay(true)} checked={chooseKeep} className={radio} />
                          <span>Yes</span>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
            )}
          {((confirmed && processingState !== 'submitting') || showBetBuilderOddsAcceptance) && (
            <OfferButtons
              offer={offer}
              isLoggedIn={isLoggedIn}
              eventInRunning={eventInRunning}
              handleSubmit={handleSubmit}
              editModal={editModal}
              offerIndex={offerIndex}
              confirmed={confirmed}
              isNew={isNew}
              setEditModal={setEditModal}
              setConfirmed={setConfirmed}
              reset={reset}
              countdown={countdown}
              onRemoveMultipleSelection={onRemoveMultipleSelection}
              onRemoveOffer={onRemoveOffer}
              onCancelOffer={onCancelOffer}
              onCancelUnmatchedOffers={onCancelUnmatchedOffers}
              cashoutAvailable={cashoutAvailable}
              marketStatus={marketStatus}
              selectRunner={selectRunner}
              setShowCashout={setShowCashout}
              showCashout={showCashout}
              history={history}
              processingState={processingState}
              activeOffer={activeOffer}
              aggregationRule={aggregationRule}
              isMBZero={isMBZero}
              betData={betData}
              oddsType={oddsType}
              setEditUnmatched={setEditUnmatched}
              editUnmatched={editUnmatched}
              unmatchedData={unmatchedData}
              setUnmatchedData={setUnmatchedData}
              handleEdit={handleEdit}
              resetEditing={resetEditing}
              showBetBuilderOddsAcceptance={showBetBuilderOddsAcceptance}
              acceptNewBetBuilderOdds={acceptNewBetBuilderOdds}
            />
          )}
        </Fragment>
      )}
    </div>
  );
};

OfferInfo.propTypes = {
  offer: PropTypes.instanceOf(Record).isRequired,
  showCashout: PropTypes.bool.isRequired,
  aggregationRule: PropTypes.string.isRequired,
  oddsType: PropTypes.string.isRequired,
  unmatchedData: PropTypes.string,
  setEditModal: PropTypes.func.isRequired,
  setUnmatchedData: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  offerIndex: PropTypes.number,
  betData: PropTypes.instanceOf(Object).isRequired,
  editModal: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  updateBack: PropTypes.func.isRequired,
  handleKeepInPlay: PropTypes.func.isRequired,
  handleUseBonus: PropTypes.func.isRequired,
  updateLay: PropTypes.func.isRequired,
  oddsLadder: PropTypes.func.isRequired,
  updateOdds: PropTypes.func.isRequired,
  refOdds: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  refInputStake: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  stringIsValidNumber: PropTypes.func.isRequired,
  optionValue: PropTypes.string.isRequired,
  setConfirmed: PropTypes.func.isRequired,
  onRemoveMultipleSelection: PropTypes.func,
  onRemoveOffer: PropTypes.func,
  processingState: PropTypes.string.isRequired,
  setShowCashout: PropTypes.func.isRequired,
  cashoutAvailable: PropTypes.bool.isRequired,
  chooseKeep: PropTypes.bool.isRequired,
  marketStatus: PropTypes.string,
  selectRunner: PropTypes.func.isRequired,
  countdown: PropTypes.number.isRequired,
  isLoggedIn: PropTypes.bool,
  onCancelOffer: PropTypes.func,
  onCancelUnmatchedOffers: PropTypes.func,
  bonusBalance: PropTypes.number,
  eventInRunning: PropTypes.bool,
  isNew: PropTypes.bool.isRequired,
  marketWillBeLive: PropTypes.bool,
  showBetConfirmation: PropTypes.bool.isRequired,
  bonusDropdownOptions: PropTypes.array.isRequired,
  bonusAllowed: PropTypes.bool.isRequired,
  updateOddsLockStatus: PropTypes.func.isRequired,
  oddsLocked: PropTypes.bool.isRequired,
  isUnsubmittedType: PropTypes.bool.isRequired,
  isBetBuilderBet: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  lastEditedInput: PropTypes.oneOf(['back', 'lay']).isRequired,
  betBuilderWithErrors: PropTypes.bool.isRequired,
  betBuilderLegsWithErrors: PropTypes.array.isRequired,
  showBetBuilderOddsAcceptance: PropTypes.bool.isRequired,
  acceptNewBetBuilderOdds: PropTypes.func.isRequired,
  newBetBuilderOdds: PropTypes.number,
  prevBetBuilderOdds: PropTypes.number,
};

export default OfferInfo;
